module.exports = __webpack_public_path__ + "img/location.13ef979d.svg";